module.exports = __webpack_public_path__ + "93dcb0c222437699e9dd591d8b5a6b85.woff2";